// Lip Imports
import axios from 'axios';
// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import DocumentEntity from 'granite-admin/common/entities/document';
import { env } from 'granite-admin/env';
const URL = env.REACT_APP_PDF_FORM_URL || process.env.REACT_APP_PDF_FORM_URL;
async function getDocuments(params, signal) {
  const payload = {
    params,
    signal
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/document/', payload);
    const list = data.results.map(item => new DocumentEntity(item));
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getDocumentWithId(documentId) {
  try {
    const {
      data
    } = await GraniteAPIClient().get(`/document/${documentId}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteDocument(documentId) {
  try {
    const {
      data
    } = await GraniteAPIClient().delete(`/document/${documentId}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getS3Url(filename) {
  const payload = {
    params: {
      filename
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/document/upload/', payload);
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function uploadS3(url, formData) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  try {
    await axios.post(url, formData, config);
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function createDocument(fileData) {
  // const payload = {params: {...params}}
  try {
    const {
      data
    } = await GraniteAPIClient().post('/document/', fileData);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function savePdfForm(payload) {
  try {
    const {
      data
    } = await GraniteAPIClient(URL).post('', payload);
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
export default {
  getDocuments,
  getDocumentWithId,
  getS3Url,
  uploadS3,
  createDocument,
  deleteDocument,
  savePdfForm
};